<svg
   width="30"
   height="30"
   viewBox="0 0 50 50"
   version="1.1"
   id="svg5"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs2" />
  <g
     id="layer1">
    <path
       style="fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000;stroke-dasharray:none"
       d="M 5,5 45,45"
       id="path353" />
    <path
       style="fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stop-color:#000000;stroke-dasharray:none"
       d="M 45,5 5,45"
       id="path355" />
  </g>
</svg>
